import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import Fa from 'react-fontawesome';
import { MenuItem, Button, Overlay, ButtonGroup } from 'react-bootstrap';

import styles from './styles.css';

function InnerPopover({ children, className, style }) {
  return (
    <div className={`${styles.menuPopover} ${className}`} style={style}>
      {children}
    </div>
  );
}
InnerPopover.propTypes = {
  children: PropTypes.element,
  className: PropTypes.string,
  style: PropTypes.shape({}),
};
InnerPopover.defaultProps = {
  className: null,
  children: null,
  style: {},
};


class ActionRenderer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
    this.handleEditClick = this.handleEditClick.bind(this);
    this.handleSelectClick = this.handleSelectClick.bind(this);
    this.handleDeselectClick = this.handleDeselectClick.bind(this);
    this.handleLogClick = this.handleLogClick.bind(this);

    this.handleToggle = this.handleToggle.bind(this);
    this.getTarget = this.getTarget.bind(this);
  }

  getTarget() {
    return ReactDOM.findDOMNode(this.target);
  }

  handleEditClick() {
    this.props.requestEdit(this.props.selectedObject);
  }
  handleToggle() {
    this.setState({ open: !this.state.open });
  }

  handleLogClick() {
    this.props.requestShowLogs(this.props.data);
  }

  handleSelectClick(e) {
    e.preventDefault();
    e.stopPropagation();
    this.props.requestSelect(this.props.data);
  }
  handleDeselectClick(e) {
    e.preventDefault();
    e.stopPropagation();
    this.props.requestDeselect(this.props.data);
  }

  renderInner() {
    const { data, disabled, isSelected } = this.props;
    const { tracking, submitted } = data;
    const canSubmitMore = tracking && !tracking.allSubmitted;
    let itemSelect = null;
    let itemEdit = null;
    let itemDiv = null;
    let itemLog = null;
    if (canSubmitMore) {
      if (isSelected) {
        itemEdit = (<MenuItem disabled={disabled} onClick={this.handleEditClick}><Fa name="edit" /> Edit</MenuItem>);
        itemSelect = (<MenuItem disabled={disabled} onClick={this.handleDeselectClick}><Fa name="minus-square-o" /> De-select</MenuItem>);
      } else {
        itemSelect = (<MenuItem disabled={disabled} onClick={this.handleSelectClick}><Fa name="plus-square-o" /> Select</MenuItem>);
      }
    }
    if (submitted && data.has_submitted_data) {
      itemDiv = canSubmitMore ? (<MenuItem divider />) : null;
      itemLog = (<MenuItem disabled={disabled} onClick={this.handleLogClick}><Fa name="clock-o" /> Show Submitted Data</MenuItem>);
    }

    return (
      <div className="clearfix open">
        <ul className="dropdown-menu">
          {itemSelect}
          {itemEdit}
          {itemDiv}
          {itemLog}
        </ul>
      </div>
    );
  }

  render() {
    const { data, disabled, isSelected } = this.props;
    const { open } = this.state;
    const { tracking } = data;
    const canSubmitMore = tracking && !tracking.allSubmitted;
    const loaded = tracking && tracking !== null && tracking !== undefined;
    if (!loaded) {
      return (<Fa name="spinner" spin />);
    }

    let mainBtn = (
      <Button
        bsSize="xs"
        bsStyle="primary"
        disabled={disabled}
        onClick={this.handleToggle}
      >
        Actions
      </Button>
    );
    if (canSubmitMore) {
      if (isSelected) {
        mainBtn = (
          <Button
            bsSize="xs"
            bsStyle="primary"
            disabled={disabled}
            onClick={this.handleEditClick}
          >
            Edit
          </Button>
        );
      } else {
        mainBtn = (
          <Button
            bsSize="xs"
            bsStyle="primary"
            disabled={(disabled || data.contactStatus === 'loading')}
            onClick={this.handleSelectClick}
          >
            <span>{data.contactStatus === 'loading' && <Fa name="spinner" spin />} Select</span>
          </Button>
        );
      }
    }
    if (!canSubmitMore && !data.has_submitted_data) {
      return null;
    }
    return (
      <div style={{ position: 'relative' }}>
        <ButtonGroup
          ref={(target) => {
            this.target = target;
          }}
        >
          {mainBtn}
          <Button
            bsSize="xs"
            bsStyle="primary"
            disabled={disabled}
            onClick={this.handleToggle}
          >
            <Fa name="caret-down" />
          </Button>
        </ButtonGroup>
        <Overlay
          show={open}
          rootClose
          onHide={() => this.setState({ open: false })}
          placement="bottom"
          target={this.getTarget}
        >
          <InnerPopover>
            {this.renderInner()}
          </InnerPopover>
        </Overlay>
      </div>
    );
  }
}

ActionRenderer.propTypes = {
  data: PropTypes.shape({
    submitted: PropTypes.bool,
    has_submitted_data: PropTypes.bool,
    contactStatus: PropTypes.string,
  }).isRequired,
  disabled: PropTypes.bool,
  isSelected: PropTypes.bool,
  selectedObject: PropTypes.shape({
  }),
  requestEdit: PropTypes.func,
  requestSelect: PropTypes.func,
  requestDeselect: PropTypes.func,
  requestShowLogs: PropTypes.func,
};
ActionRenderer.defaultProps = {
  disabled: false,
  isSelected: false,
  selectedObject: null,
  requestEdit: () => {},
  requestSelect: () => {},
  requestDeselect: () => {},
  requestShowLogs: () => {},
};

export default ActionRenderer;
